import state from '@ugc-store';
import { isPreprod, isTest } from '@ugc-utils/utils';
declare global {
  interface Window {
    IHERB_CATALOG_HOST: '';
    CATALOG_API_HOST: '';
    IHERB_CHECKOUT_HOST: '';
    IHERB_MYACCOUNT_HOST: '';
    IHERB_STATIC_HOST: '';
    SERVER_APP_STATE: '';
  }
}

export const getDomainBaseUrl = key => state.domains[key] || '';

export interface IDomains {
  catalog: string;
  catalogApi: string;
  checkout: string;
  secure: string;
  static: string;
}

const defaultTestDomains = {
  catalog: 'https://www.iherbtest.com',
  catalogApi: 'https://catalog.app.iherbtest.com',
  checkout: 'https://checkout.iherbtest.com',
  secure: 'https://secure.iherbtest.com',
  static: 'https://s3.images-iherb.com',
};

const defaultPreprodDomains = {
  catalog: 'https://www.iherbpreprod.com',
  catalogApi: 'https://catalog.app.iherbpreprod.com',
  checkout: 'https://checkout.iherbpreprod.com',
  secure: 'https://secure.iherbpreprod.com',
  static: 'https://s3.images-iherb.com',
};

const defaultProdDomains = {
  catalog: 'https://www.iherb.com',
  catalogApi: 'https://catalog.app.iherb.com',
  checkout: 'https://checkout.iherb.com',
  secure: 'https://secure.iherb.com',
  static: 'https://s3.images-iherb.com',
};

export const getDefaultDomains = () => {
  if (isTest()) return defaultTestDomains;
  if (isPreprod()) return defaultPreprodDomains;
  return defaultProdDomains;
};

export const initDomains = async () => {
  const {
    catalog: defaultCatalog,
    catalogApi: defaultCatalogApi,
    checkout: defaultCheckout,
    secure: defaultSecure,
    static: defaultS3Static,
  } = getDefaultDomains();
  if (state.isDesktop) {
    if (window.CATALOG_API_HOST) {
      state.domains = {
        catalog: window.IHERB_CATALOG_HOST || defaultCatalog,
        catalogApi: window.CATALOG_API_HOST || defaultCatalogApi,
        checkout: window.IHERB_CHECKOUT_HOST || defaultCheckout,
        secure: window.IHERB_MYACCOUNT_HOST || defaultSecure,
        static: window.IHERB_STATIC_HOST || defaultS3Static,
      };
    } else {
      state.domains = {
        catalog: defaultCatalog,
        catalogApi: defaultCatalogApi,
        checkout: defaultCheckout,
        secure: defaultSecure,
        static: defaultS3Static,
      };
    }
  } else {
    if (window.SERVER_APP_STATE) {
      const { catalogApi, catalog, checkout, secure, static: staticImage } = JSON.parse(
        decodeURIComponent(window.SERVER_APP_STATE)
      ).domains;
      state.domains = {
        catalog: catalog || defaultCatalog,
        catalogApi: catalogApi || defaultCatalogApi,
        checkout: checkout || defaultCheckout,
        secure: secure || defaultSecure,
        static: staticImage || defaultS3Static,
      };
    } else {
      state.domains = {
        catalog: defaultCatalog,
        catalogApi: defaultCatalogApi,
        checkout: defaultCheckout,
        secure: defaultSecure,
        static: defaultS3Static,
      };
    }
  }
};
